module.exports = __webpack_public_path__ + "media/entities/2106-40b6c5f2.png";